import {IOtherExpenseTransactionRecordDto} from "../../../dtos/transactions/IOtherExpenseTransactionRecordDto";
import DataGrid, {
    Column,
    ColumnChooser,
    Grouping,
    GroupPanel,
    Pager,
    Paging,
    SearchPanel
} from "devextreme-react/data-grid";
import {MovementTypeColumn} from "./MovementTypeColumn";
import React from "react";

interface IProps {
    items: IOtherExpenseTransactionRecordDto[];
}

export const OtherExpenseTransactionTable = ({items}:IProps) => {
    const pageSizes = [10, 25, 50, 100];

    return (
        <>
            <DataGrid
                dataSource={items}
                sorting={{mode: "multiple"}}
                allowColumnReordering={true}
                rowAlternationEnabled={false}
                showBorders={false}
                showRowLines={true}
                allowColumnResizing={true}
                selection={{mode: "single"}}
                loadPanel={{enabled: true, showIndicator: true, showPane: false}}
                onSelectionChanged={async (e) => {
                    // if (e.selectedRowKeys && e.selectedRowKeys.length > 0) {
                    //     setSelectedItemId(e.selectedRowKeys[0]);
                    // }
                }}
            >
                <ColumnChooser enabled={true}/>
                <GroupPanel visible={true}/>
                <SearchPanel visible={true} highlightCaseSensitive={true}/>
                <Grouping autoExpandAll={false}/>

                <Column
                    dataField="tableMovementType"
                    dataType="string"
                    caption={"Movement Type"}
                    width={100}
                    cellRender={(column: any) => {
                        return <MovementTypeColumn column={column}/>;
                    }}
                />

                <Column
                    dataField={"period"}
                    dataType={"datetime"}
                    caption={"Period"}
                    sortOrder={"asc"}
                    sortIndex={1}
                />
                <Column dataField={"companyName"} dataType="string"/>
                <Column dataField={"expenseItemName"} dataType="string"/>
                <Column
                    dataField={"amount"}
                    dataType="number"
                    format={"fixedPoint"}
                />

                <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true}/>
                <Paging defaultPageSize={10}/>
            </DataGrid>
        </>
    )
}